import getExternalClientId from '../../src/helpers/get-external-client-id';
import generateDpaConfig from './generate-dpa-transaction-config';
import OrchCustomData from './orch-custom-data';

const generateInitData = (configs, network) => {
  if (network !== 'VISA') {
    return generateDpaConfig(configs, network);
  }

  const {
    buttonCardBrands,
    cert,
    correlationId,
    initialBranding,
    isInteropEligible,
    merchantConfig,
    merchantIntegrationType,
    sdkParams,
    sessionId,
    vInitRequest,
    vsbSDKLoadEnd
  } = configs;

  const apikey = vInitRequest.apikey || null;
  const externalClientId = getExternalClientId(configs) || null;
  const externalProfileId = configs.vInitRequest.externalProfileId || 'SYSTEMDEFAULT';

  // set apikey, correlationId and sessionId for orch payment data api
  OrchCustomData.apikey = apikey;
  // TODO set profileid, externalClientId;
  OrchCustomData.externalClientId = externalClientId;
  OrchCustomData.externalProfileId = externalProfileId;
  OrchCustomData.correlationId = correlationId;
  OrchCustomData.sessionId = sessionId;

  const visaCustomInitData = {
    customData: {
      apikey,
      configs: {
        buttonCardBrands,
        cert,
        initialBranding,
        isInteropEligible,
        merchantConfig,
        sdkParams,
        vInitRequest
      },
      correlationId,
      domain: '',
      externalClientId,
      externalProfileId,
      sessionId
    },
    data: configs,
    isVsb: configs.isVsb,
    isVsbButtonless: configs.isVsbButtonless,
    merchantIntegrationType,
    visaSrci: true,
    vsbSDKLoadEnd
  };

  return visaCustomInitData;
};
export default generateInitData;
